import { render, staticRenderFns } from "./EWReceiveMoney.vue?vue&type=template&id=c9b13412&"
import script from "./EWReceiveMoney.vue?vue&type=script&lang=js&"
export * from "./EWReceiveMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports